import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import SubUserComponent from "../../components/company/sub-user/SubUserComponent";
import IdNameModel from "../../models/common/IdNameModel";
import { RoleEnum } from "../../models/enums/RoleEnum";
import { GuidEnum } from "../../models/enums/GuidEnum";
import departmentService from "../../services/company/department-service";
import toasterUtils from "../../utils/toaster-utils";
import masterDataService from "../../services/master-data-service";
import { useHistory } from "react-router";
import Alert from '@mui/material/Alert';

const SubUser = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [roles, setRoles] = useState<IdNameModel[]>([]);
    const [city, setCity] = useState<IdNameModel[]>([]);
    const [departments, setDepartments] = useState<IdNameModel[]>([]);

    useEffect(() => {
        fillUserTypes();
        fillDepartments();
        fillCities(1);
    }, []);

    const fillUserTypes = () => {
        let roles: IdNameModel[] = [];
        let roleRecruiter: IdNameModel = {
            id: RoleEnum.ClientRecruiter,
            name: "Client Recruiter",
            guId: GuidEnum.Empty
        }
        roles.push(roleRecruiter);
        let rolePanel: IdNameModel = {
            id: RoleEnum.ClientLead,
            name: "Client Lead",
            guId: GuidEnum.Empty
        }
        roles.push(rolePanel);
        setRoles(roles);
    };

    const fillDepartments = () => {
        if (loggedInUser) {
            departmentService.fillDepartments(loggedInUser.profileId).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setDepartments(res.items);
            }).catch((error) => {
                toasterUtils.showError(error);
            });
        }
    };

    const fillCities = (countryId: number) => {
        masterDataService.loadCities(countryId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCity(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Sub User
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> SUB USER </h4>
            </div>
            {departments.length < 1 &&
                <Alert severity="info">Please Add Department to add SubUser.</Alert>
            }
            {roles.length > 0 && departments.length > 0 && city.length > 0 &&
                <SubUserComponent
                    roles={roles}
                    departments={departments}
                    cities={city} />
            }
        </Layout>
    );
};
export default SubUser;